import { defineComponent, PropType, Ref, toRef } from 'vue';
import DisciplineComponent from './Discipline.class';
import { FacetValues } from '@studyportals/search-api-interface';
import { setupComponent } from '@studyportals/vue-platform';


export default defineComponent({
	props: {
		discipline: {
			type: Object as PropType<FacetValues>,
			required: true,
		}
	},
	setup: (props: any) => {
		const discipline: Ref<FacetValues> = toRef(props, 'discipline') as Ref<FacetValues>;
		const component = new DisciplineComponent(discipline);
		return setupComponent(component);
	},
});